import type { PricingGroup } from '@/lib/catalog'

export const currencyNote = 'Prices are shown in USD. When an XAF conversion is offered, it uses the live exchange rate available at the time of calculation. The final checkout or invoice amount is authoritative.'

export function getVisiblePricingNote(group: PricingGroup) {
  const note = group.note && !/fixed commercial rate|taux commercial fixe|fixed commercial conversion/i.test(group.note)
    ? group.note
    : null
  return [note, group.extraStorageNote].filter(Boolean).join(' ')
}
